// extracted by mini-css-extract-plugin
export default {"main":"_995e6b8739 _470e305c7e","xmark":"_53fc0d8f68","fl_img":"ad11149908 _5c8fcaa1f5"};